<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import SizeInput from "./SizeInput.vue";

const props = defineProps({
  variants: {
    type: Array,
    required: true
  },
  product: {
    type: Object,
    required: true
  },
  composition: {
    type: Object,
    required: true
  }
});
const store = useStore();
const selectedCompQuantities = computed(() => store.getters["product/selectedCompQuantities"]);
const inventory = computed(() => store.getters["product/inventory"]);
const onChange = qty => store.dispatch("product/handleQtyUpdate", qty);
</script>

<template>
  <div class="product-sizes">
    <h4 class="product-sizes__title">Size & quantity</h4>
    <div class="product-sizes__wrapper">
      <SizeInput
        v-for="variant in props.variants"
        :id="variant.id"
        :key="variant.id"
        class="product-sizes__item"
        :size="variant.size"
        :value="selectedCompQuantities[variant.id]"
        :product="product"
        :composition="composition"
        :disabled="!!inventory[product.id] && inventory[product.id][variant.id] === 0"
        @on-change="onChange"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/pod/settings";

.product-sizes {
  margin: 0 auto;

  &__title {
    color: $black;
    font-size: 15px;
    font-weight: 500;
    text-align: center;

    @include with-tablet {
      text-align: left;
    }
  }

  &__wrapper {
    margin-top: 16px;
    display: grid;
    grid-template-columns: repeat(3, 28%);
    gap: 16px;
    justify-content: space-between;

    @include with-tablet {
      gap: 20px;
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &__item {
    margin: auto;
  }
}
</style>
